import { IAdminShop, IAdminSimpleShop } from '../../interfaces/shop.interface'
import {
  IAdminShopOperations,
  IAdminShopsResponse,
  IAdminUnimportedShopsResponse
} from '../../interfaces/admin-shops-response.interface'
import { IAdminGroupsResponse } from '../../interfaces/admin-groups-response.interface'

export interface AdminShopsStateModel {
  shop: IAdminShop
  shopOperations: IAdminShopOperations
  allShops: IAdminSimpleShop[]
  allShopsResponse: IAdminShopsResponse
  allGroupsResponse: IAdminGroupsResponse
  unimportedShopsResponse: IAdminUnimportedShopsResponse
}
